import React from 'react';
import ErrorMessage from '../../Elements/ErrorMessage.js';
import dateTimeHelper from '../../Helpers/datetimeHelper.js';
import TimeSheetEntryService from '../../Services/timeSheetEntryService.js';
import ListViewHeader from './ListViewHeader.js';
import TimesheetHelper from '../../Helpers/ModelHelpers/TimesheetHelper.js';

class ListView extends React.Component {
  static defaultProps = {
    selectedDate: new Date(),
    selectedEndDate: null,
    timeSheetEntryListChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      timeSheetEntryForList: [],
    };
  }

  populateTimeSheetEntries() {
    const selectedDate = dateTimeHelper.toYYYYsMMsDD(this.props.selectedDate);
    const selectedDateAsDate = new Date(selectedDate);

    const endDateFromSelected = this.props.selectedEndDate
      ? new Date(dateTimeHelper.toYYYYsMMsDD(this.props.selectedEndDate))
      : dateTimeHelper.addDaysToDate(selectedDateAsDate.getDate(), 7);
    TimeSheetEntryService.GetTimeSheetEntriesSplitByDay(selectedDateAsDate, endDateFromSelected, null, null, null, null)
      .then((result) => {
        const timeSheetEntries = TimesheetHelper.GetSpentHoursForEntries(
          TimeSheetEntryService.ConvertDBTimesheetEntries(result, true)
        );
        this.setState({ timeSheetEntryForList: timeSheetEntries });
        this.props.timeSheetEntryListChange(timeSheetEntries);
      })
      .catch(() => ErrorMessage.SetErrorMessage('LV33'));
  }

  componentDidMount() {
    this.populateTimeSheetEntries();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps !== this.props &&
      (Math.abs(dateTimeHelper.calculateTimeDifference(prevProps.selectedDate, this.props.selectedDate)) > 1 ||
        Math.abs(dateTimeHelper.calculateTimeDifference(prevProps.selectedEndDate, this.props.selectedEndDate)) > 1)
    ) {
      this.populateTimeSheetEntries();
    }

    if (JSON.stringify(prevProps.timeSheetEntryList) !== JSON.stringify(this.props.timeSheetEntryList)) {
      this.setState({ timeSheetEntryForList: this.props.timeSheetEntryList });
    }
  }

  render() {
    const rows = this.state.timeSheetEntryForList || [];
    return (
      <div className='table-wrap'>
        <table className='grid'>
          <ListViewHeader />
          <tbody>
            {rows.map((entry, index) => (
              <tr className='data-row' key={`key${index}`}>
                <td data-label='Lead'>{entry.leadName || <span className='muted'>Not set</span>}</td>
                <td data-label='Client'>{entry.clientName || <span className='muted'>Not set</span>}</td>
                <td data-label='Opportunity'>{entry.opportunityName || <span className='muted'>Not set</span>}</td>
                <td data-label='Project'>{entry.cfName || <span className='muted'>Not set</span>}</td>
                <td data-label='Survey'>{entry.surveyName || <span className='muted'>Not set</span>}</td>
                <td data-label='TP Project'>{entry.projectName || <span className='muted'>Not set</span>}</td>
                <td data-label='TP Survey'>{entry.tpSurveyName || <span className='muted'>Not set</span>}</td>
                <td data-label='Start – End' style={{ fontVariantNumeric: 'tabular-nums' }}>
                  {entry.startDate}<br />{`${entry.startTime} – ${entry.endTime}`}
                </td>
                <td data-label='Spent hours' className='num num-strong'>{entry.spentHours}</td>
                <td data-label='Task'>{entry.taskName}</td>
                <td data-label='Comment'>{entry.comment || <span className='muted'>—</span>}</td>
                <td data-label='Outsourced?' className='ctr'>{entry.isOutsourced === true ? 'Yes' : 'No'}</td>
                <td data-label='Billed Office'>{entry.billedOfficeName || <span className='muted'>Not set</span>}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr className='empty-row'>
                <td colSpan='13'>
                  <div className='empty-state'>
                    <b>No activity this week</b>
                    <span>Add an entry or refresh from Jira.</span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ListView;
